'use client';

import Script from 'next/script';
import { useEffect } from 'react';

// Creates Meta's fbq stub if absent. The stub queues calls until fbevents.js loads,
// so PageViews fired before FacebookPixel's effect runs are buffered, not dropped.
const ensureFbq = (): FacebookQueue | undefined => {
  if (typeof window === 'undefined') {
    return undefined;
  }
  if (!window.fbq) {
    const fbq: FacebookQueue = function (...args: unknown[]) {
      if (fbq.callMethod) {
        fbq.callMethod(...args);
      } else {
        fbq.queue.push(args);
      }
    };
    fbq.push = fbq;
    fbq.loaded = true;
    fbq.queue = [];
    fbq.version = '2.0';
    window.fbq = fbq;
    // eslint-disable-next-line no-underscore-dangle
    window._fbq = fbq;
  }
  return window.fbq;
};

const pixelId = process.env.NEXT_PUBLIC_FACEBOOK_PIXEL_ID;

export const FacebookPixel = () => {
  useEffect(() => {
    if (pixelId && typeof window !== 'undefined' && !window.E2E_TEST) {
      ensureFbq()?.('init', pixelId);
    }
  }, []);

  if (!pixelId || typeof window === 'undefined' || process.env.E2E_TEST) {
    return null;
  }

  return (
    <Script id="facebook-pixel" src="https://connect.facebook.net/en_US/fbevents.js" strategy="afterInteractive" />
  );
};
